
import { useEffect, useRef, useState } from 'react';

export default function PrivilegeProtected() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      title: 'Protected in Transit',
      delay: '0ms',
    },
    {
      title: 'Deleted After Processing',
      delay: '200ms',
    },
    {
      title: 'Never Used for Training',
      delay: '400ms',
    },
  ];

  return (
    <section id="privacy" ref={sectionRef} className="relative py-32 bg-white">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-16">
          <h2
            className={`text-[#09090b] text-[56px] font-bold leading-tight mb-8 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Your Sensitive Data Stays Yours
          </h2>

          <div
            className={`space-y-6 max-w-[800px] mx-auto transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <p className="text-[#52525b] text-[20px] leading-relaxed">
              Your sensitive data is protected, processed, and deleted. We do not store documents. We do not store audio. We do not train on your data.
            </p>

            <p className="text-[#52525b] text-[20px] leading-relaxed">
              When your document is generated, the container terminates. Your data ceases to exist.
            </p>

            <p className="text-[#09090b] text-[22px] leading-relaxed font-semibold">
              Nothing to subpoena. Nothing to breach
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-[900px] mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`group bg-[#f5f0e8] border border-[#e8dcc8] rounded-2xl p-8 text-center hover:border-[#8B4513] hover:shadow-[0_0_30px_rgba(139,69,19,0.1)] hover:-translate-y-2 transition-all duration-300 cursor-pointer ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: feature.delay }}
            >
              <h3 className="text-[#09090b] text-[18px] font-bold group-hover:text-[#8B4513] transition-colors">
                {feature.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
